import { render, staticRenderFns } from "./addressItem.vue?vue&type=template&id=4f8816dc&scoped=true"
import script from "./addressItem.vue?vue&type=script&lang=js"
export * from "./addressItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8816dc",
  null
  
)

export default component.exports